<template>
    <div v-html="html"></div>
</template>

<script>
const styleOrEmpty = (value, name) => (value ? `${name}:${value};` : '');

export const buildDefaultHtml = (props = {}) => {
    const tag = props.tag || 'h2';
    const text = props.text || '';
    const color = styleOrEmpty(props.color, 'color');
    const fontSize = styleOrEmpty(props.fontSize, 'font-size');
    const fontFamily = styleOrEmpty(props.fontFamily, 'font-family');
    const lineHeight = styleOrEmpty(props.lineHeight, 'line-height');
    const align = styleOrEmpty(props.align, 'text-align');
    const padding = styleOrEmpty(props.padding, 'padding');
    return `<div style="${align}${padding}"><${tag} style="margin:0;${color}${fontSize}${fontFamily}${lineHeight}">${text}</${tag}></div>`;
};

export default {
    name: 'MailingBlockTitle',
    props: {
        html: { type: String, default: '' },
    },
};
</script>
